import React from 'react';
import { Link } from 'react-router-dom';
import Header from "../layouts/Header/";
import Footer from "../layouts/Footer";

// Import necessary components (assuming these exist in your project structure)
import SectionHeading from "../components/SectionHeading";

const Products = () => {
  // Inline styles
  const styles = {
    productTile: {
      backgroundColor: '#ffffff',
      borderRadius: '10px',
      padding: '30px 20px',
      height: '100%',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
      color: '#333',
      marginBottom: '30px'
    },
    serviceIcon: {
      backgroundColor: 'rgba(0, 123, 255, 0.1)',
      width: '70px',
      height: '70px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 20px',
      fontSize: '28px',
      color: '#0d6efd'
    },
    title: {
      color: '#333',
      marginTop: '15px',
      marginBottom: '15px',
      fontWeight: '600'
    },
    description: {
      color: '#666',
      marginBottom: '20px'
    },
    button: {
      backgroundColor: '#0d6efd',
      color: 'white',
      padding: '8px 20px',
      borderRadius: '30px',
      fontWeight: '500',
      textDecoration: 'none',
      display: 'inline-block',
      marginTop: '15px',
      textTransform: 'uppercase',
      fontSize: '14px',
      letterSpacing: '1px',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.3s ease'
    }
  };

  const products = [
    {
      id: 1,
      title: "Multi-Chain Explorer",
      description: "Comprehensive blockchain explorer supporting multiple chains, providing real-time data, transaction history, and smart contract analysis across various networks.",
      icon: "icon ti-layers",
      url: "multichain-explorer"
    },
    {
      id: 2,
      title: "Crypto Price AI",
      description: "AI-driven price prediction and analysis tool for cryptocurrencies, offering insights into market movements and potential investment opportunities.",
      icon: "icon ti-stats-up",
      url: "crypto-price-ai"
    },
    {
      id: 3,
      title: "Crypto Data Hub",
      description: "Centralized platform for cryptocurrency data analytics, providing comprehensive market information, historical data, and customizable dashboards.",
      icon: "icon ti-server",
      url: "cryptodatahub"
    },
    {
      id: 4,
      title: "Whitepaper AI",
      description: "AI-powered analysis tool that extracts key insights from blockchain whitepapers, evaluates project viability, and identifies potential red flags for investors.",
      icon: "icon ti-file",
      url: "try-now"
    },
    {
      id: 5,
      title: "Social Media Sentiment AI",
      description: "Advanced AI-powered sentiment analysis for social media platforms, tracking market trends and public opinion on cryptocurrencies and blockchain projects.",
      icon: "icon ti-twitter", // Assuming you're using the same icon library as in other components
      url: "social-sentiment-ai"
    },
  ];

  return (
    <>
    <Header />
    <section className="our-products section section-padding-100 service_single_content_area">
      <div className="container">
        <SectionHeading
          title="Our Products"
          text="Explore our suite of AI-powered blockchain and cryptocurrency tools designed to give you the edge in digital asset markets."
        />
        
        <div className="row" style={{ margin: '0 -15px' }}>
          {products.map((product, index) => (
            <div className="col-12 col-md-6 col-lg-4" key={product.id} style={{ padding: '15px' }}>
              <div 
                className="service_single_content text-center wow fadeInUp" 
                data-wow-delay={`0.${index + 2}s`}
                style={styles.productTile}
              >
                <div style={styles.serviceIcon}>
                  <i className={product.icon}></i>
                </div>
                <h6 style={styles.title}>{product.title}</h6>
                <p style={styles.description}>{product.description}</p>
                <Link 
                  to={`/products/${product.url}`} 
                  style={styles.button}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = '#0b5ed7';
                    e.currentTarget.style.boxShadow = '0 5px 15px rgba(13, 110, 253, 0.3)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = '#0d6efd';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  Learn More
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
    <Footer />
    </>
  );
};

export default Products;
